import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Marker.prototype.options.icon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// helper to fit bounds when route changes
const FitBounds = ({ route }) => {
  const map = useMap();
  useEffect(() => {
    if (route && route.length > 0) {
      map.fitBounds(route);
    }
  }, [route, map]);
  return null;
};

const RouteMap = ({ startValue, endValue, selectedPump }) => {
  const [route, setRoute] = useState(null);

  useEffect(() => {
    const fetchRoute = async () => {
      if (!startValue || !endValue) return;

      const [startLat, startLng] = startValue.split(",").map(Number);
      const [endLat, endLng] = endValue.split(",").map(Number);

      let pumpLat, pumpLng;
      if (selectedPump) {
        pumpLat = selectedPump.coords.lat;
        pumpLng = selectedPump.coords.lon;
      }

      try {
        let url = `https://router.project-osrm.org/route/v1/driving/${startLng},${startLat}`;
        if (selectedPump) {
          url += `;${pumpLng},${pumpLat}`;
        }
        url += `;${endLng},${endLat}?overview=full&geometries=geojson`;
        const res = await fetch(url);
        const data = await res.json();

        if (data.routes.length > 0) {
          const coords = data.routes[0].geometry.coordinates.map((c) => [
            c[1],
            c[0],
          ]);
          setRoute(coords);
        }
      } catch (err) {
        console.error("Error fetching route:", err);
      }
    };

    fetchRoute();
  }, [startValue, endValue, selectedPump]);

  return (
    <MapContainer
      center={[24.7136, 46.6753]} // fallback center
      zoom={10}
      style={{ height: "400px", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />

      {/* Start Marker */}
      {startValue && (
        <Marker position={startValue.split(",").map(Number)}>
          <Popup>Start Point</Popup>
        </Marker>
      )}

      {selectedPump && (
        <Marker position={[selectedPump.coords.lat, selectedPump.coords.lon]}>
          <Popup>{selectedPump.station}</Popup>
        </Marker>
      )}

      {/* End Marker */}
      {endValue && (
        <Marker position={endValue.split(",").map(Number)}>
          <Popup>Destination</Popup>
        </Marker>
      )}

      {/* Route */}
      {route && <Polyline positions={route} color="blue" />}

      {/* Auto fit bounds */}
      {route && <FitBounds route={route} />}
    </MapContainer>
  );
};

export default RouteMap;
